/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import './css/FlightsModal.css';
import { ReactComponent as Close } from '../../../images/close-r.svg';
import { SELECT_FLIGHT } from '../../../Utils/Constants/GlobalConstants';
import FlightRoundTrip from '../../FlightRoundTrip/FlightRoundTrip';
import { isCheapestFlight } from '../../../Utils/FlightUtils';

function FlightsModal(props) {
  const {
    isVisible,
    modalNode,
    handleModalClick,
    flights,
    cheapestPrice,
    handleSelect,
    scrollNode,
  } = props;

  return (
    <div
      className={`flights_modal_container ${
        isVisible ? 'flights_modal_open' : ''
      }`}
    >
      <div
        className="flights_modal"
        ref={(node) => {
          modalNode.current = node;
        }}
      >
        <div className="flights_modal_title_line">
          <div className="bm_text_26">{SELECT_FLIGHT}</div>
          <button
            type="button"
            className="flights_close_but"
            onClick={handleModalClick}
          >
            <Close />
          </button>
        </div>
        <div
          ref={(node) => {
            scrollNode.current = node;
          }}
          className="blue_scroll_container flights_modal_tickets"
        >
          {flights.map((flight, index) => (
            <div className="mb_30" key={index}>
              <FlightRoundTrip
                flight={flight}
                isSelection
                cheapestPrice={cheapestPrice}
                handleSelect={handleSelect}
                cheapest={isCheapestFlight(flight, flights)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

FlightsModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  modalNode: PropTypes.instanceOf(Object).isRequired,
  scrollNode: PropTypes.instanceOf(Object).isRequired,
  handleModalClick: PropTypes.func.isRequired,
  flights: PropTypes.instanceOf(Array).isRequired,
  cheapestPrice: PropTypes.number,
  handleSelect: PropTypes.func.isRequired,
};

FlightsModal.defaultProps = {
  cheapestPrice: null,
};

export default FlightsModal;
